import { ApiClient } from '@brent/shared/api'
import { userPool } from './cognito'

/**
 * Member portal API client instance
 * Uses shared ApiClient from @brent/shared for consistent authentication and error handling
 */
const apiClient = new ApiClient({
  baseUrl: import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000',
  timeout: 10000, // 10 seconds
  userPool,
  onUnauthorized: () => {
    // Redirect to login page on 401
    window.location.href = '/auth'
  },
})

export default apiClient
